import httpRequest from ".";
import { BaseService } from "@/api/baseService";

export class VerificationService extends BaseService<unknown, unknown, unknown, unknown> {
    // 身份证手机号姓名认证接口
    public async verificationThreeFactorAuth(params: { name: string; identifyNum: string }): Promise<{
        resultBizCode: string;
    }> {
        const { data } = await this.service.post(`${this.path}/personal/three/factor/auth?origin=${1}`, params);
        return data;
    }

    // 主动查询人脸认证结果
    public async verificationFactorAuthResult(): Promise<{
        errorMessage: string;
        passed: number;
    }> {
        const { data } = await this.service.get(`${this.path}/face/auth/result`);
        return data;
    }
}

export const verificationService = new VerificationService("/customer/verification", httpRequest);
